import React from 'react';
import PropTypes from 'prop-types';
import './Dockbar.scss';

const Dockbar = ({ children }) => {
    return (
        <nav className="dockbar navbar fixed-bottom navbar-light bg-light">
            {children}
        </nav>
    );
}

Dockbar.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.element,
    ])
};

export default Dockbar;
